import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RowUpdateService {
  reloadData$ = new BehaviorSubject<any>(null);

  rowUpdated: EventEmitter<void> = new EventEmitter<void>();
  constructor() { }

  emitRowUpdate() {
    this.rowUpdated.emit();
  }
}
